module.exports = __webpack_public_path__ + "static/media/background_small.37de7bf3.mp4";